import { render } from "./EETaskLand.vue?vue&type=template&id=464529dc"
import script from "./EETaskLand.vue?vue&type=script&lang=js"
export * from "./EETaskLand.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__